import React, { useEffect, useState } from "react";
import styles from "./kycAndAcValidate.module.css";
import { Tabs, Tab, Divider, CircularProgress } from "@mui/material";
import BasicKyc from "../KycTabs/BasicKyc/BasicKyc";
import AdvancedKyc from "../KycTabs/AdvancedKyc/AdvancedKyc";
import ValidateBankAc from "../KycTabs/ValidateBankAc/ValidateBankAc";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config/config";
import store from "../../Store/Store";
import { observer } from "mobx-react";
const KycAndAcValidate = observer(() => {
  const [tabValue, setTabValue] = useState(0);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const v = Number(params.get("tab"));
    setTabValue(Number.isFinite(v) ? v : 0);
    if (store.userType == "AxisUser") {
      navigate("/content/transactions");
      
    }
  }, [location.search, store.refresh]);

  useEffect(() => {
    const fetchStatus = async () => {
      setLoading(true); // ✅ Start loader
      try {
        let tokens = localStorage.getItem("authToken");
        let parsedTokens = JSON.parse(tokens);
        const res = await fetch(
          `${config.kyc_api_endpoint}/user/status?company_id=${store.Company_Id}`,
          {
            method: "POST", // ← changed to POST
            headers: {
              "Content-Type": "application/json",
              aws_cognito_id_token: parsedTokens.IdToken,
              aws_cognito_access_token: parsedTokens.AccessToken,
            },
            body: JSON.stringify({
              company_id: store.Company_Id,
              kyc_company_id: store.KycCompanyId,
            }),
          },
        );

        const data = await res.json();

        if (!res.ok || !data.success) {
          throw new Error(data.error || "Failed to fetch status");
        }
        store.setKycCompanyId(data.company_id);
        setCompanyId(data.company_id);
      } catch (err) {
        console.log("❌ Fetch status failed:", err.message);
      } finally {
        setLoading(false); // ✅ Stop loader
      }
    };

    fetchStatus();
  }, [store.refresh]);

  return (
    <>
      {/* ✅ Full-screen Loader */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress size={60} sx={{ color: "#2348AB" }} />
        </div>
      )}

      {/* ✅ Tabs + Content */}
      <div className={styles.container}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(newValue)}
          variant="scrollable"
          slotProps={{
            indicator: {
              sx: { backgroundColor: "#2348AB" },
            },
          }}
        >
          {["Basic KYC", "Advanced KYC", "Verify Bank Account details / Load Money"].map((label) => (
            <Tab
              key={label}
              label={label}
              classes={{
                root: styles.tabRoot,
                selected: styles.tabSelected,
              }}
              sx={{
                "&.Mui-selected": { color: "#2348AB" },
              }}
            />
          ))}
        </Tabs>

        <Divider />

        {/* ✅ Render tab contents only after data loaded */}
        {!loading && (
          <>
            {tabValue === 0 && <BasicKyc companyId={companyId} />}
            {tabValue === 1 && <AdvancedKyc companyId={companyId} />}
            {tabValue === 2 && <ValidateBankAc companyId={companyId} />}
          </>
        )}
      </div>
    </>
  );
});

export default KycAndAcValidate;
